module.exports = __webpack_public_path__ + "static/slide11-e8afef1f63fca91b3c9facc6cd843782.jpg";